function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_29",
  "data-name": "Rectangle 29",
  width: 161,
  height: 38,
  fill: "#fff",
  opacity: 0.36
})), /*#__PURE__*/React.createElement("filter", {
  id: "Rectangle_28",
  x: 4.5,
  y: 0.5,
  width: 40,
  height: 40,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 2,
  input: "SourceAlpha"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.5,
  result: "blur"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0.051
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "blur"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})), /*#__PURE__*/React.createElement("filter", {
  id: "Ellipse_1",
  x: 20.844,
  y: 19.509,
  width: 6.427,
  height: 6.434,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 1,
  input: "SourceAlpha"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5,
  result: "blur-2"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0.161
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "blur-2"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Mask_Group_1",
  "data-name": "Mask Group 1",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_146",
  "data-name": "Group 146",
  transform: "translate(11.445 5.32)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_122",
  "data-name": "Path 122",
  d: "M11.4-72.689c-3.444,0-6.444,1.961-6.444,5.281s2.32,4.6,6,5.491c2.661.628,3.6,1.516,3.6,3.033,0,1.386-1.3,2.275-2.948,2.275a3.584,3.584,0,0,1-3.73-3.007H4.2c.339,3.791,3.157,5.7,7.461,5.7,3.548,0,6.652-1.935,6.652-5.334,0-2.9-1.774-4.732-5.739-5.648-2.87-.68-3.835-1.438-3.835-2.955,0-1.464,1.1-2.144,2.53-2.144,1.878,0,2.9,1.15,3.1,2.981h3.678C17.662-70.232,15.7-72.689,11.4-72.689ZM25.357-59.773l4.3,5.491H34.2l-6.237-7.452,6.157-6.458H29.792l-5.583,6.354V-73.5h-3.6v19.218h3.6v-4.236Zm18.287,5.491h3.522a24.093,24.093,0,0,1-.261-3.53v-4.5c0-.758-.026-1.49-.078-2.144-.209-2.406-1.67-4.1-5.557-4.1-3.313,0-5.844,1.778-5.948,4.915l3.5-.027c.1-1.516.887-2.353,2.322-2.353,1.409,0,2.035.706,2.139,1.673a11.4,11.4,0,0,1,.052,1.307v.287h-.887c-5.035,0-7.644,1.726-7.644,4.785,0,2.641,2.061,4.053,4.461,4.053a6.018,6.018,0,0,0,3.444-.915l.678-1.49Zm-3-2.17c-1.278,0-2.113-.575-2.113-1.8,0-1.83,1.93-2.484,4.8-2.275v1.124a2.668,2.668,0,0,1-2.687,2.955ZM58.489-68.558a6.121,6.121,0,0,0-3.6.967l-1.044,1.516v-2.118h-3.6v19.034h3.6v-6.981l.913,1.438a6.482,6.482,0,0,0,3.261.785c3.574,0,6.652-2.562,6.652-7.582C64.671-65.6,62.375-68.558,58.489-68.558ZM57.315-56.453c-1.67,0-3.47-1.124-3.47-4.288v-.654c0-3.4,1.617-4.628,3.6-4.628,2.139,0,3.5,1.909,3.5,4.759,0,3.216-1.539,4.811-3.626,4.811ZM75.263-68.558a6.121,6.121,0,0,0-3.6.967l-1.044,1.516v-2.118h-3.6v19.034h3.6v-6.981l.913,1.438a6.482,6.482,0,0,0,3.261.785c3.574,0,6.652-2.562,6.652-7.582C81.445-65.6,79.15-68.558,75.263-68.558ZM74.089-56.453c-1.67,0-3.47-1.124-3.47-4.288v-.654c0-3.4,1.617-4.628,3.6-4.628,2.139,0,3.5,1.909,3.5,4.759C77.715-58.047,76.176-56.453,74.089-56.453Zm11.243-1.856a2.086,2.086,0,0,0-1.565.62,2.1,2.1,0,0,0-.6,1.576,2.1,2.1,0,0,0,.6,1.576,2.086,2.086,0,0,0,1.565.62,2.093,2.093,0,0,0,1.58-.613,2.1,2.1,0,0,0,.611-1.583,2.1,2.1,0,0,0-.611-1.583,2.093,2.093,0,0,0-1.58-.613Zm6.652-15.06A1.859,1.859,0,0,0,90-71.46a1.845,1.845,0,0,0,1.983,1.909,1.845,1.845,0,0,0,1.983-1.909,1.858,1.858,0,0,0-1.982-1.909Zm1.8,19.087v-13.91h-3.6v13.91Zm9.6-14.276c-4.618,0-7.2,3.085-7.2,7.321,0,4.209,2.583,7.321,7.2,7.321s7.2-3.112,7.2-7.321C110.585-65.473,108-68.558,103.385-68.558Zm0,12.106c-2.165,0-3.47-1.8-3.47-4.785,0-3.007,1.3-4.785,3.47-4.785s3.47,1.778,3.47,4.785C106.855-58.257,105.55-56.453,103.385-56.453Z",
  transform: "translate(32.123 77.063)",
  fill: "#4e4e4e"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_145",
  "data-name": "Group 145",
  transform: "translate(-1.536 -1.536)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1, 0, 0, 1, -9.91, -3.78)",
  filter: "url(#Rectangle_28)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_28-2",
  "data-name": "Rectangle 28",
  width: 31,
  height: 31,
  rx: 5,
  transform: "translate(9 3)",
  fill: "#1dbf73"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_144",
  "data-name": "Group 144",
  transform: "translate(2.896 3.929)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_142",
  "data-name": "Group 142",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_140",
  "data-name": "Group 140",
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_139",
  "data-name": "Group 139"
}, /*#__PURE__*/React.createElement("g", {
  id: "Path_113",
  "data-name": "Path 113"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_123",
  "data-name": "Path 123",
  d: "M690.144,600.97a.913.913,0,0,1-.491-.142.93.93,0,0,1-.32-1.242l10.231-18.361a.928.928,0,0,1,1.281-.349.922.922,0,0,1,.342.349l10.227,18.358a.931.931,0,0,1-.81,1.385h0a.925.925,0,0,1-.763-.4,11.455,11.455,0,0,0-7.165-4.746l-.113-.023.048-.106a2.434,2.434,0,0,0,.221-1.018,2.459,2.459,0,0,0-.074-.6l-.035-.14.141.027a13.3,13.3,0,0,1,4.145,1.535l-6.633-11.906-6.635,11.906a13.257,13.257,0,0,1,4.144-1.533l.141-.027-.035.14a2.458,2.458,0,0,0-.074.6,2.43,2.43,0,0,0,.221,1.018l.048.105-.113.023a11.461,11.461,0,0,0-7.165,4.749A.924.924,0,0,1,690.144,600.97Z",
  transform: "translate(-689.123 -580.656)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_124",
  "data-name": "Path 124",
  d: "M689.935,600.67a.832.832,0,0,0,.688-.362,11.606,11.606,0,0,1,7.222-4.787,2.549,2.549,0,0,1-.152-1.678,13.232,13.232,0,0,0-4.407,1.7l6.881-12.347,6.879,12.347a13.255,13.255,0,0,0-4.408-1.7,2.556,2.556,0,0,1-.152,1.68,11.6,11.6,0,0,1,7.222,4.784.836.836,0,0,0,1.417-.885L700.9,581.061a.828.828,0,0,0-.308-.313.836.836,0,0,0-1.154.313L689.2,599.422a.839.839,0,0,0,.289,1.12.819.819,0,0,0,.442.128m0,.184a1.006,1.006,0,0,1-.539-.156,1.022,1.022,0,0,1-.352-1.365l10.232-18.361a1.019,1.019,0,0,1,1.407-.383,1.011,1.011,0,0,1,.376.383l10.227,18.358a1.02,1.02,0,0,1-1.729,1.079,11.364,11.364,0,0,0-7.107-4.708l-.227-.046.1-.211a2.337,2.337,0,0,0,.212-.98,2.37,2.37,0,0,0-.071-.579l-.07-.28.283.054a13.393,13.393,0,0,1,3.89,1.387l-6.4-11.479-6.4,11.48a13.348,13.348,0,0,1,3.889-1.386l.283-.053-.07.279a2.361,2.361,0,0,0,.141,1.557l.1.211-.226.046a11.372,11.372,0,0,0-7.108,4.711A1.016,1.016,0,0,1,689.935,600.854Z",
  transform: "translate(-688.914 -580.448)",
  fill: "#fff"
}))))), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1, 0, 0, 1, -12.8, -7.71)",
  filter: "url(#Ellipse_1)"
}, /*#__PURE__*/React.createElement("ellipse", {
  id: "Ellipse_1-2",
  "data-name": "Ellipse 1",
  cx: 1.713,
  cy: 1.717,
  rx: 1.713,
  ry: 1.717,
  transform: "translate(22.34 20.01)",
  fill: "#fff"
}))))));

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 161,
    height: 38,
    viewBox: "0 0 161 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.85fd3eaf.svg";
export { ForwardRef as ReactComponent };